// App.js
import React from "react";
import Header from "./components/Header";
import AuthModal from "./components/AuthModal";
import Navbar from "./components/Navbar";
import PostsList from "./components/PostsList";
import Banner from "./components/Banner";

function App() {
  return (
    <div>
      <Header />
      <Banner />
      <AuthModal /> {/* Updated to use AuthModal */}
      <Navbar />
      <div className="container">
        <PostsList />
      </div>
    </div>
  );
}

export default App;
